import { useMemo, useState } from "react";
  import {
    Box,
    Button,
    Container,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    Typography,
    useMediaQuery,
  } from "@mui/material";
  import { createTheme, ThemeProvider } from "@mui/material/styles";
  import { Link as RouterLink, Route, Routes } from "react-router-dom";
  import GalleryPage from "./pages/GalleryPage";
  import "./App.css";

  const itineraryDays = [
    {
      day: "Friday, 3/6",
      premise: "Departure to Rome",
      title: "Departure from Philadelphia to Rome",
      details: [
        "Depart from Philadelphia International Airport on American Airlines Flight 0718",
        "Leaving 6:35 PM and arriving in Rome at 9:00 AM on Saturday, 3/7",
      ],
      wikiLinks: [
        { label: "Rome", url: "https://en.wikipedia.org/wiki/Rome" },
        { label: "Philadelphia International Airport", url: "https://en.wikipedia.org/wiki/Philadelphia_International_Airport" },
      ],
    },
    {
      day: "Saturday, 3/7",
      premise: "Rome: Colosseum",
      title: "ROME: Colosseum",
      idAlert: true,
      details: [
        "Arrive 9:00 am FCO",
        "Arrive at Hotel Santa Chiara ~11:00 am",
        "Santa Maria Sopra Minerva",
        "Pantheon (exterior)",
        "Sant'Ignazio",
        { text: "Lunch @ Enoteca Corsi (reserved, 12:30 pm)", inlineLinks: [{ label: "Enoteca Corsi", url: "https://www.google.com/maps/search/?api=1&query=Enoteca+Corsi+Rome" }] },
        "Stop back at hotel, pick up headsets",
        "Leave hotel at 2:45 pm (assuming Sawyer not entering at 3)",
        "Colosseum – 4:00 pm (students); 3:00 pm (Sawyer)",
        { text: "Dinner @ Miscellanea (reserved, 7:00 pm)", inlineLinks: [{ label: "Miscellanea", url: "https://www.google.com/maps/search/?api=1&query=Miscellanea+Rome" }] },
        "Trevi Fountain",
        "Gelateria della Palma",
      ],
      restaurantMenus: [
        { label: "Enoteca Corsi – Menu", url: "https://enoteca-corsi.wheree.com/menu" },
        { label: "Miscellanea – Website", url: "https://www.miscellaneapub.com/" },
      ],
      wikiLinks: [
        { label: "Colosseum", url: "https://en.wikipedia.org/wiki/Colosseum" },
        { label: "Pantheon, Rome", url: "https://en.wikipedia.org/wiki/Pantheon,_Rome" },
        { label: "Santa Maria Sopra Minerva", url: "https://en.wikipedia.org/wiki/Santa_Maria_sopra_Minerva" },
        { label: "Sant'Ignazio, Rome", url: "https://en.wikipedia.org/wiki/Sant%27Ignazio,_Rome" },
      ],
    },
    {
      day: "Sunday, 3/8",
      premise: "Rome: Roman Forum & Pantheon",
      title: "ROME: Roman Forum, Pantheon",
      idAlert: true,
      details: [
        "8:30 am: Basilica of Saint Peter in Chains – Michelangelo's Moses",
        "9:30 am–12:00 pm: Forum and Palatine Hill",
        "Lunch",
        "2:00 pm: Basilica of San Clemente",
        "4:00 pm: Pantheon",
        { text: "Dinner @ Da Pancrazio (reserved, 7:30 pm)", inlineLinks: [{ label: "Da Pancrazio", url: "https://www.google.com/maps/search/?api=1&query=Da+Pancrazio+Rome" }] },
        "Largo Argentina (mini lecture in packet)",
        "Giolitti's",
      ],
      restaurantMenus: [
        { label: "Da Pancrazio – English Website", url: "https://www.ristorantepancrazio.it/en/" },
      ],
      wikiLinks: [
        { label: "Roman Forum", url: "https://en.wikipedia.org/wiki/Roman_Forum" },
        { label: "Palatine Hill", url: "https://en.wikipedia.org/wiki/Palatine_Hill" },
        { label: "Pantheon, Rome", url: "https://en.wikipedia.org/wiki/Pantheon,_Rome" },
        { label: "San Pietro in Vincoli", url: "https://en.wikipedia.org/wiki/San_Pietro_in_Vincoli" },
        { label: "Moses (Michelangelo)", url: "https://en.wikipedia.org/wiki/Moses_(Michelangelo)" },
        { label: "Basilica of San Clemente", url: "https://en.wikipedia.org/wiki/Basilica_of_San_Clemente" },
        { label: "Largo di Torre Argentina", url: "https://en.wikipedia.org/wiki/Largo_di_Torre_Argentina" },
      ],
    },
    {
      day: "Monday, 3/9",
      premise: "Rome: Vatican Tour & Ara Pacis",
      title: "ROME: Vatican Tour, Ara Pacis",
      details: [
        "Leave in time to explore St. Peter's Square: Bernini's design, obelisk",
        "9:30 am: Vatican Museum",
        "After Vatican tour: enter the Basilica of St. Peter, see Michelangelo's Pietà",
        "Optional: climb to the cupola for the view of Rome from atop the Basilica",
        "Lunch along Borgo Pio",
        { text: "Lunch recs near Vatican: Be.Re. + Trapizzino (best option!)", inlineLinks: [{ label: "Be.Re.", url: "https://www.google.com/maps/search/?api=1&query=Be.Re.+restaurant+Rome+Borgo+Pio" }, { label: "Trapizzino", url: "https://www.google.com/maps/search/?api=1&query=Trapizzino+Piazza+Risorgimento+Rome" }] },
        { text: "Lunch recs near Castel Sant'Angelo: Biblio Bar, La Salumeria, O'Pazzariello, Il Pastaio di Roma", inlineLinks: [{ label: "Biblio Bar", url: "https://www.google.com/maps/search/?api=1&query=Biblio+Bar+Rome" }, { label: "La Salumeria", url: "https://www.google.com/maps/search/?api=1&query=La+Salumeria+Rome" }, { label: "O'Pazzariello", url: "https://www.google.com/maps/search/?api=1&query=O%27Pazzariello+Rome" }, { label: "Il Pastaio di Roma", url: "https://www.google.com/maps/search/?api=1&query=Il+Pastaio+di+Roma+Rome" }] },
        "After lunch walk: along Tiber to Mausoleum of Hadrian, Ara Pacis, Mausoleum of Augustus",
        { text: "Dinner @ Il Baccanale (reserved, 7:00 pm)", inlineLinks: [{ label: "Il Baccanale", url: "https://www.google.com/maps/search/?api=1&query=Il+Baccanale+Rome" }] },
        "Piazza Navona (mini-lecture in packet)",
        "Gelateria del Teatro",
        "Students pack for Naples trip",
      ],
      restaurantMenus: [
        { label: "Il Baccanale – TripAdvisor", url: "https://www.tripadvisor.com/Restaurant_Review-g187791-d1627378-Reviews-Baccanale-Rome_Lazio.html" },
      ],
      wikiLinks: [
        { label: "St. Peter's Square", url: "https://en.wikipedia.org/wiki/St._Peter%27s_Square" },
        { label: "Vatican Museums", url: "https://en.wikipedia.org/wiki/Vatican_Museums" },
        { label: "Sistine Chapel", url: "https://en.wikipedia.org/wiki/Sistine_Chapel" },
        { label: "Raphael Rooms", url: "https://en.wikipedia.org/wiki/Raphael_Rooms" },
        { label: "St. Peter's Basilica", url: "https://en.wikipedia.org/wiki/St._Peter%27s_Basilica" },
        { label: "Pietà (Michelangelo)", url: "https://en.wikipedia.org/wiki/Piet%C3%A0_(Michelangelo)" },
        { label: "Castel Sant'Angelo", url: "https://en.wikipedia.org/wiki/Castel_Sant%27Angelo" },
        { label: "Ara Pacis", url: "https://en.wikipedia.org/wiki/Ara_Pacis" },
        { label: "Mausoleum of Augustus", url: "https://en.wikipedia.org/wiki/Mausoleum_of_Augustus" },
        { label: "Piazza Navona", url: "https://en.wikipedia.org/wiki/Piazza_Navona" },
      ],
    },
    {
      day: "Tuesday, 3/10",
      premise: "Naples/Sorrento: Museum & Herculaneum",
      title: "NAPLES/SORRENTO: Naples Museum, Herculaneum",
      details: [
        "8:00 am: Transfer to Stazione Termini",
        "Train information (Rome to Naples):",
        "Stazione di Partenza: Roma Termini Ore 08:53 - 10/03/2026",
        "Stazione di Arrivo: Napoli Centrale Ore 10:00 - 10/03/2026",
        "Treno: Frecciarossa 9601 Servizio: 2° Standard",
        "10:15 am: Meet reserved bus",
        "Option A: Capodimonte Museum (10:30–12:00), then lunch, then Herculaneum ~1:30 pm (30-min drive)",
        "Option B: Herculaneum in the morning, lunch in town ~1:00 pm, then drive to Sorrento",
        { text: "Lunch recs in Naples: Osteria da Carmela, Re Lazzarone, Pizzeria dal Presidente, Pizzeria e Trattoria del Purgatorio, Gino e Toto Sorbillo", inlineLinks: [{ label: "Osteria da Carmela", url: "https://www.google.com/maps/search/?api=1&query=Osteria+da+Carmela+Naples" }, { label: "Re Lazzarone", url: "https://www.google.com/maps/search/?api=1&query=Re+Lazzarone+Naples" }, { label: "Pizzeria dal Presidente", url: "https://www.google.com/maps/search/?api=1&query=Pizzeria+dal+Presidente+Naples" }, { label: "Pizzeria e Trattoria del Purgatorio", url: "https://www.google.com/maps/search/?api=1&query=Pizzeria+Trattoria+del+Purgatorio+Naples" }, { label: "Gino e Toto Sorbillo", url: "https://www.google.com/maps/search/?api=1&query=Gino+Sorbillo+Naples" }] },
        "Drive to Herculaneum",
        "Herculaneum",
        "Drive to Sorrento",
        { text: "Dinner @ Ristorante Pizzeria Tasso (7:30 pm, Sorrento)", inlineLinks: [{ label: "Ristorante Pizzeria Tasso", url: "https://www.google.com/maps/search/?api=1&query=Ristorante+Pizzeria+Tasso+Sorrento" }] },
        "Lots of gelato in the area",
      ],
      restaurantMenus: [
        { label: "Ristorante Pizzeria Tasso – English Menu", url: "https://www.ristorantetasso.com/en/menu/" },
      ],
      wikiLinks: [
        { label: "Capodimonte Museum", url: "https://en.wikipedia.org/wiki/Capodimonte_Museum" },
        { label: "Herculaneum", url: "https://en.wikipedia.org/wiki/Herculaneum" },
        { label: "Sorrento", url: "https://en.wikipedia.org/wiki/Sorrento" },
      ],
    },
    {
      day: "Wednesday, 3/11",
      premise: "Sorrento: Pompeii",
      title: "SORRENTO: Pompeii",
      details: [
        "8:30 am: Bus to Pompeii",
        "9:30 am–1:00 pm: Pompeii",
        { text: "Lunch @ Mercato Pompeiano Pizzeria (1:30 pm)", inlineLinks: [{ label: "Mercato Pompeiano Pizzeria", url: "https://www.google.com/maps/search/?api=1&query=Mercato+Pompeiano+Pizzeria+Pompeii" }] },
        "Bus back to Sorrento",
        { text: "Dinner @ Ristorante Parrucchiano (7:00 pm)", inlineLinks: [{ label: "Ristorante Parrucchiano", url: "https://www.google.com/maps/search/?api=1&query=Ristorante+Parrucchiano+Sorrento" }] },
        "Gelato",
        "Pack!",
      ],
      restaurantMenus: [
        { label: "Mercato Pompeiano Pizzeria – Website", url: "https://www.mercatopompeiano.it/" },
        { label: "Ristorante Parrucchiano – English Menu", url: "https://www.menualacarte.cloud/menu/parrucchiano/en/180" },
      ],
      wikiLinks: [
        { label: "Pompeii", url: "https://en.wikipedia.org/wiki/Pompeii" },
        { label: "Sorrento", url: "https://en.wikipedia.org/wiki/Sorrento" },
        { label: "Mount Vesuvius", url: "https://en.wikipedia.org/wiki/Mount_Vesuvius" },
      ],
    },
    {
      day: "Thursday, 3/12",
      premise: "Rome: Capitoline Museum",
      title: "ROME: Capitoline Museum",
      details: [
        "Transfer to Naples train station",
        "Train information (Naples to Rome):",
        "Stazione di Partenza: Napoli Centrale Ore 09:50 - 12/03/2026",
        "Stazione di Arrivo: Roma Termini Ore 11:00 - 12/03/2026",
        "Treno: Frecciarossa 9628 Servizio: 2° Standard",
        "Lunch near Capitoline Hill",
        { text: "Lunch recs: Giggetto, Taverna del Ghetto, Casalino Osteria Kosher, Ristorante Pizzeria Taverna degli Amici, Grano Trattoria, Fonzi the Burger's House", inlineLinks: [{ label: "Giggetto", url: "https://www.google.com/maps/search/?api=1&query=Giggetto+Rome" }, { label: "Taverna del Ghetto", url: "https://www.google.com/maps/search/?api=1&query=Taverna+del+Ghetto+Rome" }, { label: "Casalino Osteria Kosher", url: "https://www.google.com/maps/search/?api=1&query=Casalino+Osteria+Kosher+Rome" }, { label: "Ristorante Pizzeria Taverna degli Amici", url: "https://www.google.com/maps/search/?api=1&query=Taverna+degli+Amici+Rome" }, { label: "Grano Trattoria", url: "https://www.google.com/maps/search/?api=1&query=Grano+Trattoria+Rome" }, { label: "Fonzi the Burger's House", url: "https://www.google.com/maps/search/?api=1&query=Fonzi+the+Burgers+House+Rome" }] },
        "Musei Capitolini",
        "Caravaggio stops: Sant'Agostino, San Luigi dei Francesi",
        { text: "Dinner @ Emma Pizzeria (6:30 pm)", inlineLinks: [{ label: "Emma Pizzeria", url: "https://www.google.com/maps/search/?api=1&query=Emma+Pizzeria+Rome" }] },
        "La Romana (gelato)",
        "Unpack from Naples, pack for Florence",
      ],
      restaurantMenus: [
        { label: "Emma Pizzeria – English Website", url: "https://emmapizzeria.com/en/" },
      ],
      wikiLinks: [
        { label: "Capitoline Museums", url: "https://en.wikipedia.org/wiki/Capitoline_Museums" },
        { label: "Capitoline Hill", url: "https://en.wikipedia.org/wiki/Capitoline_Hill" },
        { label: "Roma Termini railway station", url: "https://en.wikipedia.org/wiki/Roma_Termini_railway_station" },
        { label: "Sant'Agostino, Rome", url: "https://en.wikipedia.org/wiki/Sant%27Agostino,_Rome" },
        { label: "San Luigi dei Francesi", url: "https://en.wikipedia.org/wiki/San_Luigi_dei_Francesi" },
        { label: "Caravaggio", url: "https://en.wikipedia.org/wiki/Caravaggio" },
      ],
    },
    {
      day: "Friday, 3/13",
      premise: "Florence Day Trip",
      title: "FLORENCE: day trip",
      details: [
        "7:45 am transfer to Stazione Termini",
        "Train information (Rome to Florence):",
        "Stazione di Partenza: Roma Termini Ore 08:35 - 13/03/2026",
        "Stazione di Arrivo: Firenze S. M. Novella Ore 10:11 - 13/03/2026",
        "Treno: Frecciarossa 9490 Servizio: 2° Standard",
        "Accademia: 10:45–11:15 am",
        "Museo dell'Opera del Duomo: 11:30 am–12:15 pm",
        "Santa Reparata: 12:30 pm",
        { text: "Lunch @ All'Antico Vinaio (Via dei Neri location)", inlineLinks: [{ label: "All'Antico Vinaio", url: "https://www.google.com/maps/search/?api=1&query=All%27Antico+Vinaio+Via+dei+Neri+Florence" }] },
        "Bargello Museum: 2:00–3:00 pm",
        "Santa Croce: 3:00–4:00 pm",
        { text: "Dinner @ Ristorante Boccadama (4:00 pm)", inlineLinks: [{ label: "Ristorante Boccadama", url: "https://www.google.com/maps/search/?api=1&query=Ristorante+Boccadama+Florence" }] },
        "6:30 pm: Train from Firenze S. M. Novella (20-min walk from dinner)",
        "Train information (Florence to Rome):",
        "Stazione di Partenza: Firenze S. M. Novella Ore 18:30 - 13/03/2026",
        "Stazione di Arrivo: Roma Termini Ore 20:11 - 13/03/2026",
        "Treno: Frecciarossa 8525 Servizio: 2° Standard",
        "8:10 pm: Transfer to hotel",
        "Gelato @ Frigidarium or Gunther",
      ],
      restaurantMenus: [
        { label: "All'Antico Vinaio – English Menu", url: "https://www.allanticovinaio.com/il_menu_en/" },
        { label: "Ristorante Boccadama – Menu", url: "https://boccadamafirenze.com/menu/" },
      ],
      wikiLinks: [
        { label: "Florence", url: "https://en.wikipedia.org/wiki/Florence" },
        { label: "Galleria dell'Accademia", url: "https://en.wikipedia.org/wiki/Galleria_dell%27Accademia" },
        { label: "Opera del Duomo Museum", url: "https://en.wikipedia.org/wiki/Museo_dell%27Opera_del_Duomo_(Florence)" },
        { label: "Bargello", url: "https://en.wikipedia.org/wiki/Bargello" },
        { label: "Santa Croce, Florence", url: "https://en.wikipedia.org/wiki/Santa_Croce,_Florence" },
        { label: "Santa Maria Novella Railway Station", url: "https://en.wikipedia.org/wiki/Firenze_Santa_Maria_Novella_railway_station" },
      ],
    },
    {
      day: "Saturday, 3/14",
      premise: "Tivoli Day Trip",
      title: "TIVOLI: day trip",
      details: [
        "8:00 am: Transfer from hotel to Tivoli (bus)",
        "9:00 am: Explore the remains of Hadrian's Villa; tour the site and museum",
        "Drive to center of Tivoli to see remains of temples",
        "Lunch in Tivoli",
        { text: "Lunch recs: Alice Pizza (quick), La Fraschetta Dell'Imperatore (amazing, massive sandwiches)", inlineLinks: [{ label: "Alice Pizza", url: "https://www.google.com/maps/search/?api=1&query=Alice+Pizza+Tivoli" }, { label: "La Fraschetta Dell'Imperatore", url: "https://www.google.com/maps/search/?api=1&query=La+Fraschetta+Dell%27Imperatore+Tivoli" }] },
        "Gardens and fountains of Villa D'Este",
        "Return to Rome",
        "7:30 pm: Dinner in Rome",
        "After dinner walk: Campo De' Fiori, FataMorgana Chiavari, Pantheon",
      ],
      wikiLinks: [
        { label: "Tivoli, Lazio", url: "https://en.wikipedia.org/wiki/Tivoli,_Lazio" },
        { label: "Hadrian's Villa", url: "https://en.wikipedia.org/wiki/Hadrian%27s_Villa" },
        { label: "Villa d'Este", url: "https://en.wikipedia.org/wiki/Villa_d%27Este" },
      ],
    },
    {
      day: "Sunday, 3/15",
      premise: "Departure Day",
      title: "Departure Day",
      details: [
        "9:30 am: Depart from hotel for transfer to airport",
        "American Airlines Flight 0719, departing Rome at 1:10 PM",
        "Arriving in Philadelphia 5:55 pm local time (EST)",
      ],
      wikiLinks: [
        { label: "Leonardo da Vinci–Fiumicino Airport", url: "https://en.wikipedia.org/wiki/Leonardo_da_Vinci%E2%80%93Fiumicino_Airport" },
        { label: "American Airlines", url: "https://en.wikipedia.org/wiki/American_Airlines" },
        { label: "Philadelphia", url: "https://en.wikipedia.org/wiki/Philadelphia" },
      ],
    },
  ];

  const siteResources = [
    {
      city: "Rome",
      categories: [
        {
          category: "Gelato",
          links: [
            { title: "Best Gelato in Rome — Katie Parla's Expert Guide", url: "https://katieparla.com/best-gelato-rome-guide/" },
            { title: "5 Best Gelato Spots in Rome — Juliëtte's Forks & Footprints", url: "https://www.juliettesforksandfootprints.com/blog-posts/best-gelato-rome-2025" },
            { title: "12 Glorious Gelato Shops in Rome — Embrace Some Place", url: "https://embracesomeplace.com/best-gelato-rome-italy/" },
            { title: "13 Best Gelato Shops Ranked — Travel Folk", url: "https://thetravelfolk.com/best-gelato-in-rome-italy/" },
          ],
        },
        {
          category: "Coffee",
          links: [
            { title: "Coffee Near the Pantheon — Romewise", url: "https://www.romewise.com/coffee-near-rome-pantheon.html" },
            { title: "Tazza d'Oro — An American in Rome", url: "https://anamericaninrome.com/2019/04/tazza-doro-coffee-near-the-pantheon/" },
            { title: "14 Top Cafés in Rome — Independent Travel Cats", url: "https://independenttravelcats.com/best-coffee-in-rome-top-cafes-in-rome-italy/" },
          ],
        },
        {
          category: "Walking & Exploring",
          links: [
            { title: "8 Fascinating Self-Guided Walks in Rome — Never Stop Traveling", url: "https://www.neverstoptraveling.com/8-fascinating-walks-in-rome" },
            { title: "Free Self-Guided Sightseeing Walks — Rome Toolkit", url: "https://www.rometoolkit.com/walks/rome_walks.html" },
            { title: "Best Walks in Rome — Montage Travel", url: "https://montagetravel.com/best-walks-in-rome/" },
            { title: "Self-Guided Walking Tour: Colosseum to Vatican — Devour Tours", url: "https://devourtours.com/blog/self-guided-walking-tour-rome/" },
          ],
        },
        {
          category: "Trastevere (Evening Neighborhood)",
          links: [
            { title: "Trastevere Food & Culture Guide — Eating Europe", url: "https://www.eatingeurope.com/rome/twilight-trastevere/" },
            { title: "Trastevere Walking Food Tour Info — Walks of Italy", url: "https://www.walksofitaly.com/rome-tours/trastevere-food-tour/" },
          ],
        },
      ],
    },
    {
      city: "Naples & Sorrento",
      categories: [
        {
          category: "Bakeries & Pastries in Sorrento",
          links: [
            { title: "Sorrento's Famous Traditional Desserts — Go Naples", url: "https://gonaples.blog/sorrentos-famous-traditional-desserts-the-best-bakeries/" },
            { title: "Best Desserts & Snacks in Sorrento — Wanderlog", url: "https://wanderlog.com/list/geoCategory/26133/best-desserts-and-snacks-in-sorrento" },
            { title: "A'Marenna — TripAdvisor Reviews", url: "https://www.tripadvisor.com/ShowUserReviews-g187782-d11932957-r842799624-A_Marenna-Sorrento_Province_of_Naples_Campania.html" },
          ],
        },
        {
          category: "Free Time in Sorrento",
          links: [
            { title: "Top 10 Free Things to Do in Sorrento — Rayburn Tours", url: "https://www.rayburntours.com/blog/2020/01/10/top-10-free-things-to-do-on-a-school-trip-in-sorrento/" },
            { title: "17 Things to Do in Sorrento (9 Free!) — Fahey James Travel", url: "https://faheyjamestravel.com/things-to-do-in-sorrento/" },
            { title: "What to Do in Sorrento — Napleswise", url: "https://napleswise.com/sorrento/what-to-do-in-sorrento-the-definitive-visit-guide/" },
            { title: "Best Things to Do in Sorrento — Time Out", url: "https://www.timeout.com/sorrento/things-to-do/best-things-to-do-in-sorrento" },
          ],
        },
      ],
    },
    {
      city: "Florence",
      categories: [
        {
          category: "Street Food (Perfect for a Day Trip!)",
          links: [
            { title: "Best Florence Street Food — Italy Foodies", url: "https://www.italyfoodies.com/blog/florence-street-food" },
            { title: "Street Food in Florence — Destination Florence", url: "https://www.destinationflorence.com/en/blog/101-street-food-in-florence" },
            { title: "5 Best Street Foods — Eating Europe", url: "https://www.eatingeurope.com/blog/florence-street-food/" },
            { title: "7 Grab-and-Go Eateries — Devour Tours", url: "https://devourtours.com/blog/street-food-florence/" },
            { title: "Florence Street Food Guide — Through Eternity Tours", url: "https://www.througheternity.com/en/blog/food-and-wine/best-street-food-florence.html" },
          ],
        },
      ],
    },
    {
      city: "General Tips",
      categories: [
        {
          category: "Gelato Spotting 101",
          links: [
            { title: "How to Spot Real vs Fake Gelato — Katie Parla", url: "https://katieparla.com/best-gelato-rome-guide/" },
          ],
        },
        {
          category: "Italian Coffee Culture",
          links: [
            { title: "The Two Best Espressos Near the Pantheon — EuroCheapo", url: "https://www.eurocheapo.com/blog/rome-the-2-best-espressos-in-rome-steps-from-the-pantheon.html" },
          ],
        },
      ],
    },
  ];

  function ItineraryPage() {
    const [openDay, setOpenDay] = useState(null);
    const [openExpectations, setOpenExpectations] = useState(false);
    const [openResourceCity, setOpenResourceCity] = useState(null);
    const [openHowTo, setOpenHowTo] = useState(false);
    const [openHotels, setOpenHotels] = useState(false);
    const fullScreen = useMediaQuery("(max-width:600px)");

    const theme = useMemo(
      () =>
        createTheme({
          palette: {
            primary: { main: "#9B2335" },
            secondary: { main: "#1E6B42" },
            background: { default: "#f9f5ee" },
          },
          typography: {
            fontFamily: '"Lato", "Trebuchet MS", "Segoe UI", sans-serif',
          },
        }),
      []
    );

    const howToItems = [
      "Tap any day in the Daily Itinerary to see the full schedule for that day.",
      "Restaurant names in lunch rec lines are tappable — each one opens that restaurant directly in Google Maps.",
      "Each day includes Wikipedia links at the bottom so you can learn more about the places you'll visit.",
      "Site Resources has curated links for gelato, coffee, walking tours, and more — organized by city.",
      "Photo Gallery lets you view and upload trip photos.",
      "Student Readings PDF opens your pre-trip reading materials.",
      "Behavioral Expectations summarizes the rules from the pre-trip meeting with Mr. Weibley.",
    ];

    const expectations = [
      "Remember our meeting with Mr. Weibley:",
      "School rules apply even when abroad. This includes prohibitions around substances as well as hazing/pranking.",
      "School response to misbehavior will likely be elevated.",
      "This trip is not designed for tons of student free time.",
      "There will be opportunities for students to explore, usually around lunch time.",
      "Students must always travel in groups of 2, or preferably, 3 or more.",
      "Once we are in for the night, an adult must accompany you on any excursions. You must let an adult know your plans.",
    ];

    const lineText = (line) => (typeof line === "string" ? line : line.text);

    const isSectionLine = (line) => {
      const t = lineText(line);
      return t.startsWith("Train information") || t === "Hotels:" || t.endsWith("visit:");
    };

    const isSubLine = (line) => {
      const t = lineText(line);
      return t.startsWith("Stazione di") || t.startsWith("Treno:");
    };

    const renderLine = (line) => {
      if (typeof line === "string") return line;
      let parts = [line.text];
      for (const link of line.inlineLinks) {
        parts = parts.flatMap((part) => {
          if (typeof part !== "string") return [part];
          const idx = part.indexOf(link.label);
          if (idx === -1) return [part];
          return [
            part.slice(0, idx),
            <a key={link.label} href={link.url} target="_blank" rel="noreferrer" className="detail-inline-link">{link.label}</a>,
            part.slice(idx + link.label.length),
          ].filter((p) => p !== "");
        });
      }
      return parts;
    };

    return (
      <ThemeProvider theme={theme}>
        <Box className="page-shell">
          <Container maxWidth="md" className="content-wrap">
            <Typography variant="h4" className="main-title">
              The Hill School
            </Typography>
            <Typography variant="subtitle1" className="sub-title">
              Updated Itinerary (3/5/26)
            </Typography>

            <Typography variant="overline" className="section-kicker">
              Quick Access
            </Typography>
            <Grid container spacing={1.6} className="top-actions">
              <Grid item xs={6}>
                <Button
                  variant="contained"
                  fullWidth
                  component={RouterLink}
                  to="/gallery"
                  className="resource-button resource-button-gallery"
                >
                  Photo Gallery
                </Button>
              </Grid>
              <Grid item xs={6}>
                <Button
                  variant="contained"
                  fullWidth
                  component="a"
                  href={`${process.env.PUBLIC_URL}/student-readings.pdf`}
                  target="_blank"
                  rel="noreferrer"
                  className="resource-button resource-button-readings"
                >
                  Student Readings PDF
                </Button>
              </Grid>
              <Grid item xs={6}>
                <Button
                  variant="contained"
                  fullWidth
                  onClick={() => setOpenExpectations(true)}
                  className="resource-button resource-button-expectations"
                >
                  Behavioral Expectations
                </Button>
              </Grid>
              <Grid item xs={6}>
                <Button
                  variant="contained"
                  fullWidth
                  onClick={() => setOpenHowTo(true)}
                  className="resource-button resource-button-howto"
                >
                  How to Use This App
                </Button>
              </Grid>
              <Grid item xs={6}>
                <Button
                  variant="contained"
                  fullWidth
                  onClick={() => setOpenHotels(true)}
                  className="resource-button resource-button-hotels"
                >
                  Hotels
                </Button>
              </Grid>
            </Grid>

            <Typography variant="overline" className="section-kicker section-kicker-days">
              Site Resources
            </Typography>
            <Grid container spacing={1.6} className="top-actions resources-actions">
              {siteResources.map((resource) => (
                <Grid item xs={6} key={resource.city}>
                  <Button
                    variant="contained"
                    fullWidth
                    onClick={() => setOpenResourceCity(resource)}
                    className="resource-button resource-button-site"
                  >
                    {resource.city}
                  </Button>
                </Grid>
              ))}
            </Grid>

            <Typography variant="overline" className="section-kicker section-kicker-days">
              Daily Itinerary
            </Typography>
            <Grid container spacing={2.2} className="days-grid">
              {itineraryDays.map((day) => (
                <Grid item xs={6} key={`${day.day}-${day.premise}`}>
                  <Button
                    variant="contained"
                    fullWidth
                    onClick={() => setOpenDay(day)}
                    className="day-button"
                  >
                    <Box component="span" className="button-text-wrap">
                      <Box component="span" className="button-day">
                        {day.day}
                      </Box>
                      <Box component="span" className="button-premise">
                        {day.premise}
                      </Box>
                    </Box>
                  </Button>
                </Grid>
              ))}
            </Grid>
          </Container>

          <Dialog
            open={Boolean(openDay)}
            onClose={() => setOpenDay(null)}
            fullScreen={fullScreen}
            fullWidth
            maxWidth="md"
            PaperProps={{ className: "itinerary-dialog" }}
          >
            {openDay && (
              <>
                <DialogTitle className="dialog-title">
                  <Typography variant="h6" fontWeight={800}>
                    {openDay.day}
                  </Typography>
                  <Typography variant="subtitle2">{openDay.title}</Typography>
                </DialogTitle>
                <DialogContent dividers className="dialog-content">
                  {openDay.idAlert && (
                    <Box className="id-alert">
                      ⚠️ Students must bring a valid ID to enter today's sites — student ID, driver's license, or passport.
                    </Box>
                  )}
                  <Box component="ul" className="details-list">
                    {openDay.details.map((line, index) => (
                      <Box
                        component="li"
                        key={`${openDay.day}-${index}`}
                        className={
                          isSectionLine(line)
                            ? "detail-section"
                            : isSubLine(line)
                              ? "detail-subitem"
                              : "detail-item"
                        }
                      >
                        <Typography className="line">{renderLine(line)}</Typography>
                      </Box>
                    ))}
                  </Box>
                  {openDay.restaurantMenus?.length ? (
                    <>
                      <Typography className="wiki-heading">Restaurant Menus</Typography>
                      <Box component="ul" className="wiki-list">
                        {openDay.restaurantMenus.map((item) => (
                          <Box component="li" key={`${openDay.day}-${item.url}`} className="detail-item">
                            <Typography className="line">
                              <a href={item.url} target="_blank" rel="noreferrer">
                                {item.label}
                              </a>
                            </Typography>
                          </Box>
                        ))}
                      </Box>
                    </>
                  ) : null}
                  {openDay.wikiLinks?.length ? (
                    <>
                      <Typography className="wiki-heading">Wikipedia links</Typography>
                      <Box component="ul" className="wiki-list">
                        {openDay.wikiLinks.map((item) => (
                          <Box component="li" key={`${openDay.day}-${item.url}`} className="detail-item">
                            <Typography className="line">
                              <a href={item.url} target="_blank" rel="noreferrer">
                                {item.label}
                              </a>
                            </Typography>
                          </Box>
                        ))}
                      </Box>
                    </>
                  ) : null}
                </DialogContent>
                <DialogActions className="dialog-actions">
                  <Button onClick={() => setOpenDay(null)} className="close-btn">
                    Close
                  </Button>
                </DialogActions>
              </>
            )}
          </Dialog>

          <Dialog
            open={openExpectations}
            onClose={() => setOpenExpectations(false)}
            fullScreen={fullScreen}
            fullWidth
            maxWidth="sm"
            PaperProps={{ className: "itinerary-dialog" }}
          >
            <DialogTitle className="dialog-title">
              <Typography variant="h6" fontWeight={800}>
                Italy Trip Behavioral Expectations
              </Typography>
              <Typography variant="subtitle2">From Italy Meeting Agenda (3/1/2026)</Typography>
            </DialogTitle>
            <DialogContent dividers className="dialog-content">
              <Box component="ul" className="details-list">
                {expectations.map((line, index) => (
                  <Box
                    component="li"
                    key={`expectations-${index}`}
                    className={index === 0 ? "detail-section" : "detail-item"}
                  >
                    <Typography className="line">{line}</Typography>
                  </Box>
                ))}
              </Box>
            </DialogContent>
            <DialogActions className="dialog-actions">
              <Button onClick={() => setOpenExpectations(false)} className="close-btn">
                Close
              </Button>
            </DialogActions>
          </Dialog>

          <Dialog
            open={Boolean(openResourceCity)}
            onClose={() => setOpenResourceCity(null)}
            fullScreen={fullScreen}
            fullWidth
            maxWidth="md"
            PaperProps={{ className: "itinerary-dialog" }}
          >
            {openResourceCity && (
              <>
                <DialogTitle className="dialog-title">
                  <Typography variant="h6" fontWeight={800}>
                    {openResourceCity.city} Resources
                  </Typography>
                  <Typography variant="subtitle2">Links from ItalyResources.jsx</Typography>
                </DialogTitle>
                <DialogContent dividers className="dialog-content">
                  {openResourceCity.categories.map((category) => (
                    <Box key={`${openResourceCity.city}-${category.category}`} className="resource-block">
                      <Typography className="wiki-heading">{category.category}</Typography>
                      <Box component="ul" className="wiki-list">
                        {category.links.map((link) => (
                          <Box component="li" key={link.url} className="detail-item">
                            <Typography className="line">
                              <a href={link.url} target="_blank" rel="noreferrer">
                                {link.title}
                              </a>
                            </Typography>
                          </Box>
                        ))}
                      </Box>
                    </Box>
                  ))}
                </DialogContent>
                <DialogActions className="dialog-actions">
                  <Button onClick={() => setOpenResourceCity(null)} className="close-btn">
                    Close
                  </Button>
                </DialogActions>
              </>
            )}
          </Dialog>

          <Dialog
            open={openHowTo}
            onClose={() => setOpenHowTo(false)}
            fullScreen={fullScreen}
            fullWidth
            maxWidth="sm"
            PaperProps={{ className: "itinerary-dialog" }}
          >
            <DialogTitle className="dialog-title">
              <Typography variant="h6" fontWeight={800}>
                How to Use This App
              </Typography>
              <Typography variant="subtitle2">A quick guide to navigating the itinerary</Typography>
            </DialogTitle>
            <DialogContent dividers className="dialog-content">
              <Box component="ul" className="details-list">
                {howToItems.map((item, index) => (
                  <Box component="li" key={`howto-${index}`} className="detail-item">
                    <Typography className="line">{item}</Typography>
                  </Box>
                ))}
              </Box>
            </DialogContent>
            <DialogActions className="dialog-actions">
              <Button onClick={() => setOpenHowTo(false)} className="close-btn">
                Got it
              </Button>
            </DialogActions>
          </Dialog>

          <Dialog
            open={openHotels}
            onClose={() => setOpenHotels(false)}
            fullScreen={fullScreen}
            fullWidth
            maxWidth="sm"
            PaperProps={{ className: "itinerary-dialog" }}
          >
            <DialogTitle className="dialog-title">
              <Typography variant="h6" fontWeight={800}>
                Hotels
              </Typography>
              <Typography variant="subtitle2">Accommodation info for the trip</Typography>
            </DialogTitle>
            <DialogContent dividers className="dialog-content">
              <Box component="ul" className="details-list">
                <Box component="li" className="detail-section">
                  <Typography className="line">Rome (6 nights)</Typography>
                </Box>
                <Box component="li" className="detail-item">
                  <Typography className="line">Albergo Santa Chiara</Typography>
                </Box>
                <Box component="li" className="detail-item">
                  <Typography className="line">Via Santa Chiara 21, 00186 Roma</Typography>
                </Box>
                <Box component="li" className="detail-item">
                  <Typography className="line">Phone: 011-39-06-6872979</Typography>
                </Box>
                <Box component="li" className="detail-item">
                  <Typography className="line"><a href="mailto:info@albergosantachiara.com">info@albergosantachiara.com</a></Typography>
                </Box>
                <Box component="li" className="detail-item">
                  <Typography className="line"><a href="https://www.albergosantachiara.com/en/" target="_blank" rel="noreferrer">albergosantachiara.com</a></Typography>
                </Box>
                <Box component="li" className="detail-section">
                  <Typography className="line">Sorrento (2 nights)</Typography>
                </Box>
                <Box component="li" className="detail-item">
                  <Typography className="line">Hilton Sorrento Palace Hotel</Typography>
                </Box>
                <Box component="li" className="detail-item">
                  <Typography className="line">Via Rivolo S.Antonio 13, 80067 Sorrento NA</Typography>
                </Box>
                <Box component="li" className="detail-item">
                  <Typography className="line">Phone: +39 081 878 4141</Typography>
                </Box>
                <Box component="li" className="detail-item">
                  <Typography className="line"><a href="https://www.hilton.com/en/hotels/rrohihi-hilton-sorrento-palace/" target="_blank" rel="noreferrer">hilton.com – Sorrento Palace</a></Typography>
                </Box>
              </Box>
            </DialogContent>
            <DialogActions className="dialog-actions">
              <Button onClick={() => setOpenHotels(false)} className="close-btn">
                Close
              </Button>
            </DialogActions>
          </Dialog>
        </Box>
      </ThemeProvider>
    );
  }

  function App() {
    return (
      <Routes>
        <Route path="/" element={<ItineraryPage />} />
        <Route path="/gallery" element={<GalleryPage />} />
      </Routes>
    );
  }

  export default App;